module.exports = __webpack_public_path__ + "img/nv.b6e3a675.png";